import { fromJS } from "immutable";
import { name } from "./__init__";
import { actions as appActions, name as appName } from "../App";

// const TOGGLE_CHILDREN = `${name}/TOGGLE_CHILDREN`;
const RESET_ROOM = `${name}/RESET_ROOM`;
const SELECT_ROOM = `${name}/SELECT_ROOM`;
const SELECT_DISPLAY_ELEMENT = `${name}/SELECT_DISPLAY_ELEMENT`;

const SELECT_ACCOMMODATION = `${name}/SELECT_ACCOMMODATION`;
const RESET_ACCOMMODATION = `${name}/RESET_ACCOMMODATION`;

const SELECT_PACKAGE = `${name}/SELECT_PACKAGE`;

const SELECT_PROPERTY = `${name}/SELECT_PROPERTY`;
const RESET_PROPERTY = `${name}/RESET_PROPERTY`;
const ORIGIN_ACCOMMODATION = `${name}/ORIGIN_ACCOMMODATION`;

export const initialState = fromJS({
  ticker: null,
  activeChildrenMap: {},
  activeRooms: {},
  collapsedChildrenMap: {},
  initialActivationDone: false,
  initialRoomSelectionDone: false,
  activeDisplayElement: false,
  ORIGIN_ACCOMMODATION: "base",
});

export function setOriginAccommodation({ originAccommodation }) {
  return dispatch => {
    return dispatch({
      type: ORIGIN_ACCOMMODATION,
      originAccommodation,
    });
  };
}

export function roomSelected({ ticker, accommodation, activeOnly, oneTime }) {
  return (dispatch, getState) => {
    const baseTicker = getState()[appName].get("propertyTicker");

    return dispatch({
      type: SELECT_ROOM,
      baseTicker,
      ticker,
      accommodation,
      activeOnly,
      oneTime,
    });
  };
}

export function resetRoom({ ticker }) {
  return dispatch => {
    return dispatch({
      type: RESET_ROOM,
      ticker,
      accommodation: null,
    });
  };
}

export function selectActiveDisplayElement({ element, renderAsModal }) {
  return dispatch => {
    return dispatch({
      type: SELECT_DISPLAY_ELEMENT,
      element,
      renderAsModal,
    });
  };
}

export function selectAccommodation({ propertyTicker, accommodationTicker }) {
  return dispatch => {
    return dispatch({
      type: SELECT_ACCOMMODATION,
      propertyTicker,
      accommodationTicker,
    });
  };
}

export function selectPackage({ propertyTicker, packageTicker }) {
  return dispatch => {
    return dispatch({
      type: SELECT_PACKAGE,
      propertyTicker,
      packageTicker,
    });
  };
}

export function resetAccommodation({ propertyTicker }) {
  return dispatch => {
    return dispatch({
      type: RESET_ACCOMMODATION,
      propertyTicker,
    });
  };
}

export function selectProperty({ propertyTicker }) {
  return dispatch => {
    return dispatch({
      type: SELECT_PROPERTY,
      propertyTicker,
    });
  };
}

export function resetProperty({ propertyTicker }) {
  return (dispatch, getState) => {
    const baseTicker = getState()[appName].get("propertyTicker");
    return dispatch({
      type: RESET_PROPERTY,
      propertyTicker,
      baseTicker,
    });
  };
}

export default (state = initialState, action) => {
  switch (action.type) {
    case appActions.TOGGLE_CHILDREN: {
      if (action.closeOthers) {
        return state
          .set("activeChildrenMap", fromJS({}))
          .setIn(["activeChildrenMap", action.ticker], { [action.children]: true });
      }

      const childrenMap = state.getIn(["activeChildrenMap", action.ticker]);
      const currentChild = childrenMap && Object.keys(childrenMap)[0];
      const nextValue =
        currentChild === action.children ? !(childrenMap && childrenMap[currentChild]) : true;
      // if next value is false, then it means that the children is already open.
      // if we ONLY want to expand and the children is already expanded, then it makes no sense to change the state
      if (action.activeOnly && nextValue === false) {
        return state;
      }
      // Some activations must only occur at app initialization, we use this state to make sure
      // the state is not changed if it has already been changed when initialized
      let resultState = state;
      if (action.oneTime && state.get("initialActivationDone")) {
        return state;
      } else if (action.oneTime) {
        resultState = resultState.set("initialActivationDone", true);
      }
      return resultState
        .setIn(["activeChildrenMap", action.ticker], { [action.children]: nextValue })
        .set("activePropertyTicker", nextValue ? action.ticker : action.baseTicker)
        .set("activeDisplayElement", action.element);
    }

    case SELECT_ROOM: {
      // Some activations (like expand Param) must only occur at app initialization, we use this state to make sure
      // the state is not changed if it has already been changed when initialized
      let resultState = state;
      if (action.oneTime && state.get("initialRoomSelectionDone")) {
        return state;
      } else if (action.oneTime) {
        resultState = resultState.set("initialRoomSelectionDone", true);
      }

      return resultState
        .setIn(["activeRooms", action.ticker], action.accommodation)
        .set("activePropertyTicker", action.ticker)
        .set("activeDisplayElement", false);
    }
    case RESET_ROOM: {
      return state
        .setIn(["activeRooms", action.ticker], action.accommodation)
        .set("activePropertyTicker", action.ticker);
    }

    // NEW ACTIONS
    case SELECT_ACCOMMODATION: {
      return state
        .setIn(["activeRooms", action.propertyTicker], action.accommodationTicker)
        .set("activePropertyTicker", action.propertyTicker)
        .set("activeDisplayElement", false)
        .set("activeEntityType", "accommodation");
    }
    case SELECT_PACKAGE: {
      return state
        .setIn(["activeRooms", action.propertyTicker], action.packageTicker)
        .set("activePropertyTicker", action.propertyTicker)
        .set("activeDisplayElement", false)
        .set("activeEntityType", "package");
    }
    case RESET_ACCOMMODATION: {
      return state
        .setIn(["activeRooms", action.propertyTicker], null)
        .set("activePropertyTicker", action.propertyTicker);
    }
    case SELECT_PROPERTY: {
      return state
        .setIn(["activeRooms", action.propertyTicker], null)
        .set("activePropertyTicker", action.propertyTicker)
        .set("activeDisplayElement", false);
    }
    case RESET_PROPERTY: {
      return state
        .setIn(["activeRooms", action.propertyTicker], null)
        .set("activePropertyTicker", action.propertyTicker);
    }
    case appActions.SELECT_DISPLAY_ELEMENT:
    case SELECT_DISPLAY_ELEMENT: {
      return state
        .set("activeDisplayElement", action.element ? action.element : false)
        .set("renderDisplayElementAsModal", action.element ? action.renderAsModal : false);
    }
    case ORIGIN_ACCOMMODATION: {
      return state.set("originAccommodation", fromJS(action.originAccommodation));
    }
    default:
      return state;
  }
};

export const actions = {
  childrenToggled: appActions.childrenToggled,
  roomSelected,
  resetRoom,
  setOriginAccommodation,
  selectActiveDisplayElement,
  resetProperty,
  resetAccommodation,
  selectProperty,
  selectAccommodation,
  selectPackage,
};
